<template>
  <div>
    <div class="container">
      <!-- 占位 -->
      <div class="seat"></div>

      <!-- 表格区域 -->
      <div class="table_title">{{ tableName || "信息流--报名周期表的学员列表" }}</div>
      <StudentsTableHeader
        id="PeriodicReportStudentList"
        :empty-text="emptyText"
        ref="PeriodicReportStudentList"
        componentTableId="PeriodicReportStudentList"
        :table-height="tableMaxHeight"
        :excelName="tableName || '信息流--几天--报名周期表的学员列表'"
        :header-data="headerData"
        :element-loading-text="loadingText"
        @update-list="getData"
        :table-data="tableData"
        :table-loading="tableLoading"
        @search-data="tableSearch"
      >
        <template v-slot:studentNamecustom="scope">
          <span
            class="blue hand"
            v-if="scope.scope.studentName"
            @click="openDialog(scope.scope)"
            >{{ scope.scope.studentName }}</span
          >
          <span v-else class="gray hand" @click="openDialog(scope.scope)">未设置</span>
        </template>
        <template v-slot:payMoneycustom="scope">
          <span v-if="scope.scope.payMoney">{{ scope.scope.payMoney }}元</span>
          <span v-else class="gray">未设置</span>
        </template>

        <template v-slot:payCoursescustom="scope">
          <template v-if="scope.scope.payCourses && scope.scope.payCourses.length > 0">
            <el-tooltip popper-class="mt35" effect="dark" content="点击查看购买的课程列表" placement="bottom">
              <span class="hand" @click="handleScopeCourse(scope.scope, 'PayCourse')">
                共购买
                <span class="blue">
                  {{
                    scope.scope.payCourses.length
                  }}
                </span>个课程
              </span>
            </el-tooltip>
          </template>
          <span v-else class="gray">还未购买课程</span>
        </template>
      </StudentsTableHeader>

      <!-- 底部工具 -->
      <pagination-tool
        :pagination="pagination"
        :is-loading="tableLoading"
        @change-pagination="changePagination"
      >
      </pagination-tool>

      <!--购买的课程弹框-->
      <el-dialog
        :title="CourseTitle"
        :visible.sync="dialogVisibleCourse"
        v-if="dialogVisibleCourse"
        width="1200px"
        v-dialogDrag
        top="15vh"
        :close-on-click-modal="false"
      >
        <div class="dialog_div2">
          <el-table
            :data="payCourseList"
            style="width: 100%"
            border
            height="420px"
            stripe
            :header-cell-style="{ background: '#f5f7fa' }"
          >
            <el-table-column width="430" prop="title" label="课程标题" align="left"></el-table-column>
            <el-table-column prop="payMoney" label="实付金额(元)" align="center">
              <template scope="scope">
                <span v-if="scope.row.payMoney">{{ scope.row.payMoney }}元</span>
                <span v-else>免费</span>
              </template>
            </el-table-column>
            <el-table-column prop="gradeName" label="所属班级" align="center" width="410">
              <template scope="scope">
                <span v-if="scope.row.gradeName">{{ scope.row.gradeName }}</span>
                <span v-else class="gray">未设置</span>
              </template>
            </el-table-column>
            <el-table-column prop="payTime" label="购买时间" width="180" align="center">
              <template scope="scope">
                <span v-if="scope.row.payTime">{{ scope.row.payTime }}</span>
                <span v-else class="gray">未设置</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>

      <!-- 学生详情弹框（新） -->
      <StudentDialog
        title="学生详情"
        :show.sync="dialogVisibleDetail"
        v-if="dialogVisibleDetail"
        @isfullscreen="isfullscreen"
        :isFooter="false"
      >
        <div class="abow_dialog3" slot="body">
          <StudentDetailNew
            :isService="true"
            v-if="dialogVisibleDetail"
            :studentId="studentId"
            :isFullscreen="isFullscreen"
            class="dialog_div_detail1"
          ></StudentDetailNew>
        </div>
      </StudentDialog>
    </div>
  </div>
</template>

<script>
import { GetEnrollmentCycleReportStudentPage } from "@/network/statistics.js";
import StudentsTableHeader from "components/StudentList";
import PaginationTool from "components/PaginationTool";
import { isNull, timeFormatNew } from "../../../../qk-report/src/common/utils";
import { GetCatetListByType } from "network/studentSortModule";
import { getAdminList } from "network/administrator";
import StudentDialog from "components/StudentDialog";
import StudentDetailNew from "../studentsV2/studentDetailNew.vue";
import { GetStudentCourseAndClassList } from "@/network/students.js";

export default {
  name: "PeriodicReportStudentList",
  components: {
    StudentsTableHeader,
    PaginationTool,
    StudentDialog,
    StudentDetailNew,
  },
  data() {
    return {
      tableName: "信息流--报名周期表的学员列表",
      emptyText: "暂无数据",
      loadingText: "加载中...",
      tableLoading: false,
      tableData: [],
      // 从URL参数获取的查询条件
      queryParams: {},
      gradeList: [], // 年级列表
      // 来源渠道
      sourseList: [],
      // 老师列表
      adminList: [],
      businessList: [],
      educationalList: [],
      // 课程弹窗
      dialogVisibleCourse: false,
      payCourseList: [],
      CourseTitle: "",
      // 学生详情弹框
      dialogVisibleDetail: false,
      isFullscreen: false,
      studentId: null,
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          align: "center",
          width: "55",
          fixed: "left",
        },
        {
          label: "学员姓名",
          prop: "studentName",
          width: "180",
          align: "left",
          inputSearch: true,
          fixed: "left",
          custom: true,
        },
        {
          label: "手机号",
          prop: "telNumber",
          width: "160",
          align: "center",
          inputSearch: true,
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "微信号",
          prop: "weiXinNumber",
          width: "140",
          align: "center",
          inputSearch: true,
          noSetText: "未设置",
          noTooltip: true,
        },

        {
          label: "报名时间",
          prop: "signUpTime",
          align: "center",
          width: "160",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "登记时间",
          prop: "createTime",
          align: "center",
          width: "160",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "总缴费金额",
          prop: "payMoney",
          align: "center",
          width: "160",
          noSetText: "未设置",
          noTooltip: true,
          custom: true,
        },
        {
          label: "所属招生老师",
          prop: "businessName",
          align: "center",
          width: "160",
          noSetText: "未设置",
          noTooltip: true,
          selectSearch: true,
          businessId: null,
          selectOptions: [],
        },
        {
          label: "来源渠道",
          prop: "sourceStr",
          align: "left",
          width: "260",
          noSetText: "未设置",
          noTooltip: true,
          cascader: true,
          sourceStr: null,
          selectOptions: [],
        },
        {
          label: "报名课程",
          prop: "payCourses",
          align: "center",
          width: "160",
          noSetText: "未设置",
          custom: true,
        },
        {
          label: "所在年级",
          prop: "gradeStr",
          align: "center",
          width: "160",
          noSetText: "未设置",
          selectSearch: true,
          gradeStr: null,
          selectOptions: [],
        },
        {
          label: "所属教务",
          prop: "handoverName",
          align: "center",
          width: "160",
          noSetText: "未设置",
          noTooltip: true,
          selectSearch: true,
          handoverName: null,
          selectOptions: [],
        },
        {
          label: "专科院校",
          prop: "graduatedSchool",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "专科专业",
          prop: "graduatedMajor",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "报考院校",
          prop: "applySchool",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "报考专业",
          prop: "applyMajor",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },
      ],
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  computed: {
    tableMaxHeight() {
      const h = document.documentElement.clientHeight || document.body.clientHeight;
      if (h > 768) {
        return h - 160;
      } else {
        return h + 100;
      }
    },
  },
  async created() {
    this.getQueryParams();
    this.getGradeList(); // 获取年级列表
    this.getStudentCategoryList(); // 获取来源渠道
    this.getData();
  },
  mounted() {
    this.getTeacherList();
  },
  methods: {
    // 获取URL查询参数
    getQueryParams() {
      // 获取URL参数，同时兼容hash路由和普通URL
      let queryString = "";
      if (window.location.hash.includes("?")) {
        // hash路由形式
        queryString = window.location.hash.split("?")[1];
      } else {
        // 普通URL形式
        queryString = window.location.search.slice(1);
      }
      let urlParams = new URLSearchParams(queryString);
      
      // 获取所有Source参数（可能有多个）
      this.queryParams = {
        Source: urlParams.get("Source"),
        BeginTime: urlParams.get("BeginTime"),
        EndTime: urlParams.get("EndTime"),
        IsIncludeRegisterTime: urlParams.get("IsByEnrollmentTime"),
        tableName: urlParams.get("tableName"),
        reportType: urlParams.get("reportType"),
        BeginCycle: urlParams.get("BeginCycle"),
        EndCycle: urlParams.get("EndCycle"),
        BusinessId: urlParams.get("BusinessId"),
        SourceName: urlParams.get("sourceName"),
      };

      if (this.queryParams.tableName) {
        this.tableName = this.queryParams.tableName;
      } else {
        const endCycle = this.queryParams.EndCycle;
        if(endCycle == 0 && this.queryParams.BeginCycle == 365){
          this.tableName = `${this.queryParams.SourceName}--365天以上--报名周期表的学员列表`;
        }else{
          if (endCycle && endCycle !== "0") {
          this.tableName = `${this.queryParams.SourceName}--${endCycle}天--报名周期表的学员列表`;
        } else {
          this.tableName = `${this.queryParams.SourceName}--总计--报名周期表的学员列表`;
        }
        }
      }
    },

    // 获取数据
    async getData() {
      if (this.tableLoading) return;
      this.tableLoading = true;
      try {
        const params = {
          BeginSignUpTime: this.queryParams.BeginTime,
          EndSignUpTime: this.queryParams.EndTime,
          Name: this.queryParams.Name || undefined,
          TelNumber: this.queryParams.TelNumber || undefined,
          QqNumber: this.queryParams.QqNumber || undefined,
          WeiXinNumber: this.queryParams.WechatId || undefined,
          Grade: this.queryParams.Grade || undefined,
          BusinessId: this.queryParams.BusinessId || undefined,
          HandoverId: this.queryParams.HandoverId || undefined,
          PageIndex: this.pagination.currentPage,
          PageSize: this.pagination.pageSize,
          IsIncludeRegisterTime: this.queryParams.IsIncludeRegisterTime,
          BeginCycle: this.queryParams.BeginCycle,
          EndCycle: this.queryParams.EndCycle,
        };
        if(this.queryParams.Source && this.queryParams.Source !== 'null'){
          params.Source = this.queryParams.Source;
        }

        const res = await GetEnrollmentCycleReportStudentPage(params);

        if (res.code === 1) {
          this.tableData = res.result?.data || [];
          this.pagination.total = res.result?.totalRecords || 0;
        } else {
          this.$message.error(res.message || "获取数据失败");
        }
      } catch (error) {
        this.$message.error("获取数据失败");
      } finally {
        this.tableLoading = false;
      }
    },
    
    // 表格搜索
    tableSearch(val) {
      if (!isNull(val.prop) && val.prop == "studentName") {
        this.queryParams.Name = val.value;
      }
      if (!isNull(val.prop) && val.prop == "telNumber") {
        this.queryParams.TelNumber = val.value;
      }
      if (!isNull(val.prop) && val.prop == "qqNumber") {
        this.queryParams.QqNumber = val.value;
      }
      if (!isNull(val.prop) && val.prop == "weiXinNumber") {
        this.queryParams.WechatId = val.value;
      }
      if (!isNull(val.prop) && val.prop == "gradeStr") {
        this.queryParams.Grade = val.value;
      }
      if (!isNull(val.prop) && val.prop == "businessName") {
        this.queryParams.BusinessId = val.value;
      }
      if (!isNull(val.prop) && val.prop == "handoverName") {
        this.queryParams.HandoverId = val.value;
      }
      if (!isNull(val.prop) && val.prop == "sourceStr") {
        this.queryParams.Source = val.value.length ? val.value[val.value.length - 1] : 0
      }
      this.pagination.currentPage = 1;
      this.getData();
    },
    
    // 分页改变
    changePagination(pagination) {
      this.pagination = pagination;
      this.getData();
    },
    
    // 获取年级列表
    async getGradeList() {
      const result = await GetCatetListByType(4);
      if (result.code == 1) {
        let gradeList = [];
        if (result.result && result.result.length) {
          result.result.forEach((item) => {
            gradeList.push({
              key: item.id,
              value: item.name,
            });
          });
          this.gradeList = gradeList;
          // 更新表头配置
          this.headerData.forEach((item) => {
            if (item.prop === "gradeStr") {
              item.selectOptions = this.gradeList;
              item.selectOptions.unshift({ key: "0", value: "所在年级(全部)" });
            }
          });
        }
      }
    },
    
    // 获取来源渠道
    async getStudentCategoryList() {
      let sourseList = [];

      const result = await GetCatetListByType(2);
      if (result.code == 1) {
        sourseList = result.result;
        // 来源渠道
        let sourseList1 = {},
          sourseList0 = [],
          sourseList2 = {},
          sourseList3 = {};
        if (sourseList && sourseList.length) {
          sourseList.map((item) => {
            sourseList1.label = item.name;
            sourseList1.value = item.id;
            if (item.childModel && item.childModel.length > 0) {
              sourseList1.children = [];
              item.childModel.map((item1) => {
                sourseList2.label = item1.name;
                sourseList2.value = item1.id;
                if (item1.childModel && item1.childModel.length > 0) {
                  sourseList2.children = [];
                  item1.childModel.map((item2) => {
                    sourseList3.label = item2.name;
                    sourseList3.value = item2.id;
                    sourseList2.children.push(sourseList3);
                    sourseList3 = {};
                  });
                }
                sourseList1.children.push(sourseList2);
                sourseList2 = {};
              });
            }
            sourseList0.push(sourseList1);
            sourseList1 = {};
          });
          this.sourseList.push(...sourseList0);
        }
      }
      this.headerData.map((item) => {
        if (item.prop == "sourceStr") {
          item.selectOptions = this.sourseList;
        }
      });
    },
    
    // 获取老师列表
    async getTeacherList() {
      // 等配置信息接口返回后再获取老师列表
      let resolveConfig;
      const promise = new Promise((resolve) => {
        resolveConfig = resolve;
      });
      const interval = setInterval(() => {
        if (this.$store.state.allConfig) {
          clearInterval(interval);
          resolveConfig();
        }
      }, 100);
      await promise;
      var businessRoleId = this.$store.state.allConfig.businessRoleId;
      var educationalRoleId = this.$store.state.allConfig.educationalRoleId;
      let data = {
        ids: [0],
        keyWord: "",
        pageSize: 500,
        adminTypeIds: [educationalRoleId, businessRoleId],
      };

      const res = await getAdminList(data);
      if (res && res.code && res.code == 0) {
        this.$alert(res.message);
        return false;
      } else {
        this.adminList = res.result;
      }
      if (!isNull(this.adminList)) {
        res.result.forEach((item) => {
          // 确保item.id和item.name存在且有效
          if (
            item &&
            item.id !== undefined &&
            item.id !== null &&
            item.name &&
            item.rolesId !== undefined
          ) {
            if (item.rolesId == businessRoleId) {
              this.businessList.push({ key: item.id, value: item.name });
            } else if (item.rolesId == educationalRoleId) {
              this.educationalList.push({ key: item.id, value: item.name });
            }
          }
        });
        for (let item of this.headerData) {
          if (item.prop === "businessName") {
            item.selectOptions = this.businessList;
            item.selectOptions.unshift({ key: "0", value: "招生老师(全部)" });
          }
          if (item.prop === "handoverName") {
            item.selectOptions = this.educationalList;
            item.selectOptions.unshift({ key: "0", value: "所属教务(全部)" });
          }
        }
      }
    },
    
    // 查看课程详情
    async handleScopeCourse(scope, type) {
      if (type == "PayCourse") {
        const list = Array.isArray(scope.payCourses) ? scope.payCourses : [];
        if (list.length > 0) {
          this.payCourseList = list;
          this.CourseTitle = `${scope.studentName || "学员"}的购买课程列表`;
          this.dialogVisibleCourse = true;
        } else {
          this.$message.info("该学员暂无购买课程");
        }
      }
    },
    
    // 打开学生详情弹框
    openDialog(scope) {
      this.studentId = scope.id;
      this.dialogVisibleDetail = true;
    },
    
    // 全屏状态改变
    isfullscreen(val) {
      this.isFullscreen = val;
    },
  },
};
</script>

<style scoped>
.seat {
  height: 30px;
}

.container {
  padding: 20px;
  padding-right: 10px !important;
}

.table_title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #ececec;
  text-align: center;
  font-weight: bold;
  margin-top: 10px;
}

::v-deep .el-table {
  margin-top: 0 !important;
}

.blue {
  color: #409eff;
}

.gray {
  color: #c0c0c0;
}

.hand { 
  cursor: pointer;
}

.dialog_div1,
.dialog_div2 {
  padding: 10px;
}

.dialog_div_detail1 {
  height: 100%;
}

.abow_dialog3 {
  height: 70vh;
  overflow: auto;
}

.mt35 {
  margin-top: 35px;
}
</style>

